
var zh_cn = {
  pushTip: {
    pushType0: "本次推送有{nums}台设备已完成推送, 您要跳过这些设备吗?",
    pushSuccess: "是否跳转至任务详情查看推送进度?",
    push_all_by_mem: "是否推送渠道商: {mem}下的全部设备",
    push_all: "是否推全部渠道商下的全部设备",
  },
  ter: {
    state1: '激活成功',
    state2: '激活失败',
    state3: '等待激活',
    mechName: '渠道商',
    status: '状态',
    createTime: '操作时间',
    terminalNo: '终端编号',
     msg: '是否确认删除',
  },
  IncorrectaFormat: 'Wrong Format. Please Upload Xls Or Xlsx File',//new 7/9
  app_certificate_1: "一级证书",
  app_certificate_2: "二级证书",
  app_certificate_1_psp: "一级证书",
  app_certificate_2_psp: "二级证书",
  app_pushAll: '推送全部设备',
  app_uploadApp: '上传应用',
  app_No: '序号',
  app_terNo: '终端编号',
  app_name: '名称',
  psp_app_id: "应用标识",
  psp_app_version: "版本",
  app_appName: '应用名称',
  psp_app_manage: "应用管理",
  psp_unstall_manage: "卸载管理",

  app_appUpList: "应用设备更新列表",
  app_appType: '应用类型',
  app_insType: '安装类型',
  app_vStatus: '审核状态',
  app_ulTime: '上传时间',
  app_verror: '版本异常',
  app_tipterop: '提示终端操作',
  app_autocmpl: '自动完成',
  app_appLoding: '应用正在上传',
  app_newgVer: '最新版本号',
  app_fmVerIillegal: '版本号不合法，必须是数字，如1.0.0',
  app_fmVerIillegal1: '版本号不合法，必须是带v和数字，如v1.0.0',
  app_operate: '操作',
  app_type: '类型',
  app_del: '删除',
  app_pause: '暂停',
  app_continue: '继续',
  app_status: '状态',
  app_new: '新增',
  app_yes: '是',
  app_no: '否',
  app_selectAll: '全选',
  app_save: '保存',
  app_process: '进度',
  app_push: '确认推送',
  app_terminal: '终端',
  app_to: '到',
  app_offShelf: '下架',
  app_mulOffShelf: '批量下架',
  app_isOffShelf: '确定要下架应用？',
  app_isDelApp: '确定要删除应用？',
  app_chooseOneMust: '至少选择一个应用',
  app_cantDelTask: '选中包含了不能删除的任务',
  app_oneRecordMust: '至少选中一条记录',
  app_phoneIllegal: '手机号码不合法',
  app_groupName: '分类名称',
  app_sure: '确认',
  app_query: '查询',
  app_reset: '重置',
  app_cancel: '取消',
  app_edit: '编辑',
  app_add: '添加',
  app_verify: '审核',
  app_isPass: '是否通过',
  app_pass: '通过',
  app_ban: '不通过',
  app_noInput: '未填写',
  app_banReason: '拒绝原因',
  app_filter: '筛选',
  app_prePushVerify: '待送审',
  app_preVerify: '待审核',
  app_verifyPass: '通过',
  app_verifyNotPass: '不通过',
  app_success: '成功',
  app_submit: '提交',
  app_other: '其他',
  app_tip: '提示',
  app_online: '在线',
  app_offline: '离线',
  app_fileOver: '文件超过',
  app_onlyApk: '只能上传apk文件',
  app_onlyApk_2: '只能上传apk/hap文件',
  app_tipViewTask: '推送成功，请在任务管理中查看推送进度',
  app_tipMkDel: '删除应用后应用市场的应用也会同步删除，确定删除？',
  app_clearTask: '是否清空所有所有设备？',
  app_tipAppEdit: '删除将不可恢复，确定删除？',
  app_tipVerify: '确定要提交审核吗?',
  app_rqsError: '请求出错',
  app_not_auth: 'TMS未激活',
  app_mulAdd: '批量添加',
  app_select: '请选择',
  app_input: '请输入内容',
  app_inputCp: '请填写完整',
  app_inputName: '请输入名称',
  app_inputContact: '请输入联系人',
  app_inputTruePhone: '请输入正确号码',
  app_inputAddr: '请输入地址',
  app_inputVer: '请输入版本',
  app_inputVerTag: '请输入版本标识',
  app_inputID: '请输入文件的唯一标识',
  app_inputPkg: '请输入包名',
  app_noVerTag: '没有版本标识',
  app_noresetfs: '设备当前为工厂状态，请联系管理员清除',
  app_saleSt: '出厂状态',
  app_actst: '激活状态',
  app_inputIntrol: '请输入描述',
  app_selectType: '请选择应用类型',
  app_ulApp: '请上传应用',
  app_ulIcon: '请上传小图标',
  app_ulLarIcon: '请上传大图标',
  app_smVerify: '提交审核',
  app_baseInfo: '基本信息',
  app_version: '版本号',
  app_autoUpload: '自动填写',
  app_verTag: '版本标识',
  app_ID: '唯一标识',
  app_package: '应用包名',
  app_introl: '应用简介',
  app_udState: '更新说明',
  app_ulScreenShot: '请上传截图',
  app_icon: '应用小图标',
  app_larIcon: '应用大图标',
  app_screenShot: '应用截图',
  app_appVer: '应用版本',
  app_createTime: '创建时间',
  app_close: '关闭',
  app_ulNew: '上传新版',
  app_selectApp: '选择应用',
  app_testInstall: '安装测试',
  app_ulAppState: '将文件拖到此处，或点击上传，仅支持apk文件上传',
  app_ulAppState_2: '将文件拖到此处，或点击上传，仅支持apk/hap文件上传',
  app_clickUpdate: '点击上传',
  app_udType: '更新方式',
  app_allUpdate: '全量更新',
  app_asc: '升序',
  app_desc: '降序',
  app_utasc: '更新时间升序',
  app_utdesc: '更新时间降序',
  app_iconState: '144x144,大小100k以内',
  app_larIconState: '512x512,大小200k以内',
  app_autoInstall: '自动安装',
  app_addApp: '添加应用',
  app_classIntrol: '分类推荐',
  app_homeIntrol: '首页推荐',
  app_isIntroClass: '是否推荐到分类',
  app_isIntroHome: '是否推荐到首页',
  app_isUnbindApp: '确定要卸载应用？',
  app_isOffApp: '确定要下架应用？',
  app_isDelData: '确定要删除这条数据吗',
  app_inputAName: '请填入个名称',
  app_oneDeviceMust: '至少选择一个设备',
  app_fileSize: '文件大小',
  app_addPush: '添加推送',
  app_viewPushHis: '查看推送历史',
  app_pushTimes: '推送次数',
  app_hisVer: '历史版本',
  app_pushHistory: '推送历史',
  app_pushInstall: '推送安装',
  app_animatePush: '动画推送',
  app_animateMake: '定制动画',
  app_pushDevice: '已推送设备',
  app_ustart: '未开始',
  app_outofdate: '已过期',
  app_deviceNum: '设备数量',
  app_deviceName: '设备名称',
  app_deviceNo: '设备编号',
  app_pushTime: '推送时间',
  app_distributor: '渠道商',
  app_dParent: '上级渠道商',
  app_unbind: '卸载',
  app_mulUnbind: '批量卸载',
  app_mulPush: '批量推送',
  app_searchTerminal: '终端号或名称搜索',
  app_terName: '终端名称',
  app_taskName: '任务名称',
  app_taskDetail: '任务内容',
  app_deviceTotal: '设备总数',
  app_downloading: '下载中',
  app_downFail: '下载失败',
  app_update: '更新',
  app_md5Fail: 'MD5校验失败',
  app_theNewgVer: '终端上已安装最新版本',
  app_fileFmIllegal: '文件格式不正确',
  app_updateFail: '更新失败',
  app_usrCancelUpdate: '用户取消更新',
  app_pushFail: '设备离线',
  app_downFinish: '下载完成',
  app_updateSuccess: '更新成功',
  app_fail: '失败',
  app_addres: '地址',
  app_mulDel: '批量删除',
  app_allDel: '全部删除',
  app_contact: '联系人',
  app_contactPhone: '联系电话',
  app_typeName: '类型名称',
  app_customs: '定制',
  app_clear: '清除',
  app_customsTime: '定制时间',
  app_launchAnimate: '开关机动画',
  app_onLogo: '开机LOGO',
  app_animateName: '动画名称',
  app_playPlace: '播放位置',
  app_aSrcFile: '动画资源文件',
  app_asfState: '动画分解画面,注意文件名一定要是 part0.zip',
  app_downExp: '下载示例',
  app_ologoState: '动画播放停止后显示的画面',
  app_picSize: '图片尺寸',
  app_picSizeState: '填入宽*高',
  app_frame: '帧数',
  app_frameState: '每秒播放动画数量',
  app_aCycleTime: '动画循环次数',
  app_cyclePlay: '循环播放',
  app_playOnce: '播放一次',
  app_fileNameOnly: '文件名必须是',
  app_inputNumber: '请输入数字',
  app_picUlError: '图片上传错误',
  app_inputAnimateName: '请输入动画名称',
  app_selectAnimateType: '请选择动画类型',
  app_selectPlayPlace: '请选择播放位置',
  app_uploadAnimateFile: '请上传动画文件',
  app_uploadOnPic: '请上传开机图片',
  app_sureDelTip: '确定要删除？删除后将不能恢复',
  app_uploadPic: '请上传图片',
  app_launchUI: '启动界面',
  app_amechine: '台',
  app_chooseCycleType: '请选择循环方式',
  app_formatNotTrueLike: '格式不正确，如',
  app_on: '开机',
  app_off: '关机',
  app_onOff: '开关机',
  app_firm: '厂商名称',
  app_terstatus: '终端状态',
  app_fminfo: '固件信息',
  // 2017-7-28 wei add
  add_srcFwByName: '通过名称查找固件',
  app_downNum: '下载次数',
  app_pushed: '已发布',
  app_notPass: '未通过',
  app_sysType: '系统类型',
  app_sys: '系统',
  app_sysUdPack: '系统升级包',
  app_chooseFile: '选择文件',
  app_signCer: '签名证书',
  app_isUseDisCerAutoSign: '是否使用渠道商证书进行自动签名',
  app_useDis: '指定渠道商',
  app_allDisUsed: '所有渠道商通用',
  app_pushInstallTest: '推送安装测试',
  app_firmware: '固件名称',
  app_pushType: '推送类型',
  app_dv: '设备',
  // 2017-7-31 wei add
  app_fwType: '固件类型',
  app_ulNormalSt: '将文件拖到此处，或点击上传',
  app_selectChannel: '请选择渠道商',
  app_isSubmitToCheck: '是否提交审核',
  app_pleaseInputNo: '请输入终端编号',
  // 2017-8-7 wei add
  app_cnAndActive: '联机激活',
  app_clearCer: '证书清除',
  app_ofCheck: '开关验签',
  app_normal: '正常',
  app_insfail: '安装失败',
  app_checksignfail: '验签失败',
  app_netStatus: '网络状态',
  app_active: '激活',
  app_initiative: '主动',
  app_selfDestroy: '自毁',
  app_mulActive: '批量激活',
  app_selected: '已选',
  app_cerCheckOf: '验签开关',
  app_openCerCheck: '打开验签',
  app_closeCerCheck: '关闭验签',
  app_reOpen: '重新打开',
  app_reClose: '重新关闭',
  app_open: '打开',
  app_usrManage: '用户管理',
  app_stManage: '配置管理',
  app_roleManage: '角色管理',
  // 2017-8-8 wei add
  app_cerMgType: '证书管理类型',
  app_cerMgSelf: '自管证书',
  app_cerMgOther: '代管证书',
  app_cerMgCustomer: '客户定制',
  app_operateHis: '操作历史',
  app_operateType: '操作类型',
  app_time: '时间',
  app_isActive: '确定要激活吗',
  // 2017-8-8 wei add
  app_downCer: '下载证书',
  // 2017-8-10 wei add
  app_isOperate: '确定进行操作吗',
  // 2017-8-11 wei add
  app_ulSuccess: '上传成功',
  // 2017-7-31 wei add
  app_setting: '设置',
  // 2017-8-15 wei add
  app_clickPicToUlPic: '点击图片位置选择上传图片',
  app_within: '以内的',
  app_pgsFormat: 'png、gif、svg格式',
  app_sgUseAndAdUse: '建议使用svg格式，图片颜色建议使用白色',
  app_sureChange: '确认更改',
  app_logoLvTip: '有未保存的更改，是否离开',
  app_dfIcon: '默认图标',
  // 2017-8-16 wei add
  app_useBigSize: '使用大号尺寸',
  app_useBigSizeTip: 'logo视觉偏小时选择此项改善',
  // 2017-8-22 wei add
  app_or: '或',
  app_format: '格式',
  app_pic: '图片',
  app_s: '的',
  app_plsUpl: '请上传',
  // 2017-8-24
  app_upload: '上传',
  app_cerType: '证书类型',
  // 2017-8-31
  app_editProfile: '编辑资料',
  // 2017-9-1
  app_cerFile: '证书文件',
  app_plsUlPbCer: '请上传客户证书',
  app_appNoCerTip: '当前渠道商为自管证书渠道商，请上传公钥文件，以便进行应用验签',
  app_appNeedCerTip: '当前渠道商没有证书，请联系平台管理员创建',
  app_createCer: '创建证书',
  app_uploadCer: '上传证书',
  // 2017-9-4
  app_fileImport: '文件导入',
  app_mdFile: '模版文件',
  app_down: '下载',
  // 2017-9-5
  app_roleAllot: '分配角色',
  app_roleName: '角色名称',
  app_downTplFile: '下载模板文件',
  // 2017-9-7
  app_verUdCt: '版本更新内容',
  app_animation: '动画',
  app_per: '每',
  app_geo: '地理位置',
  app_minute: '分钟',
  app_hbsp: '心跳间隔',
  app_rcmsg: '接收信息',
  app_autoRefresh: '自动刷新',
  app_checkupsp: '检查更新间隔',
  app_level: '等级',
  app_firm: '厂商',
  app_model: '型号',
  app_adType: '广告类型',
  app_license: '授权码',
  app_maintain: '维护',
  app_manage: '管理',
  app_is: '是否',
  app_plsip: '请填写',
  app_reason: '理由',
  // 2017 9-26
  app_sgMc: '单台设备',
  app_ss: '简介',
  app_inst: '安装',
  app_file: '文件',
  app_printscreen: '截图',
  app_batch: '批量',
  app_recov: '还原',
  app_lc: 'launcher',
  // 2017 10-11
  app_re: '重新',
  app_sysinfo: '系统信息',
  app_confirm: '确定',
  app_df: '默认',
  app_as: '为',
  app_click: '点击',
  app_content: '内容',
  app_ttPkg: '全量包',
  app_dfPkg: '差分包',
  app_task: '任务',
  app_catch: '抓取',
  app_log: '日志',
  app_continued: '持续',
  app_sec: '秒',
  app_video: '视频',
  app_ad: '广告',
  // 2017 10-25
  app_choose: '选择',
  app_timeInterval: '时段',
  app_and: '和',
  app_play: '播放',
  app_times: '次数',
  app_sc: '次',
  app_tofvalis: '有效期',
  app_tofvaliss: '有效期限',
  app_start: '开始',
  app_end: '结束',
  app_preview: '预览',
  app_duration: '时长',
  app_size: '尺寸',
  app_personnel: '人员',
  app_cannot: '不能',
  app_early: '早于',
  app_later: '晚于',
  app_lessThan: '小于',
  app_moreThan: '大于',
  // 2017 11-14
  app_nums: '数量',
  app_waiting: '等待中',
  app_all: '全部',
  app_all1: '所有',
  app_thistime: '本次',
  app_done: '完成',
  app_areyou: '您要',
  app_skip: '跳过',
  app_these: '这些',
  app_cover: '覆盖',
  app_jump: '跳转',
  app_detail: '详情',
  app_view: '查看',
  app_now: '立即',
  app_imp: '导入',
  app_size1: '大小',
  app_taskMg: '任务管理',
  app_inssuccess: '安装成功',
  app_taskType: '任务类型',
  app_cancelPush: '取消推送',
  app_iscancelPush: '是否取消推送?',
  app_azcgsj: '安装成功时间',
  app_ispushf: '是否推送文件',
  app_autoscopen: '安装成功自动打开',
  app_pushsctipinstall: '推送成功终端提示应用下载',
  app_tipdown: '提示下载',
  app_tipud: '提示安装',
  app_bth: '回到主页',
  app_norightview: '您没有访问此页面权限',
  // 2017 11-27
  app_fault: '故障',
  app_abnormal: '异常',
  app_blockp: '卡纸',
  app_ecr: '电动读卡器',
  app_mcr: '手动读卡器',
  app_nacr: '非接读卡器',
  app_cardr: '刷卡器',
  app_tgcr: '二代证阅读器',
  app_receiptp: '凭条打印机',
  app_ispushalldv: '是否推送全部设备',
  //edit lin
  lin_btn: {
    cancel: "取消",
    add: "添加",
    install: '安装',
    batch_install: '批量安装',
    tips: '提示',
    confirm: '确定',
    unbind: '解绑',
    unbindAll: '批量解绑',
    check: '查询',
    reset: '重置',
    submit: '提交',
    restart: '重启',
    off: '关闭',
    send: '推送',
    batch_delete: '批量删除',
    delete: '删除',
    lock: '锁定',
    lockOta: '锁定OTA',
    add_zeng: '增加',
    edit: '编辑',
    save: '保存',
    bind: '绑定',
    //20170727新增edit by linziying
    bindAll: '批量绑定',
    xiezai: '卸载',
    unlock: '解锁',
    change: '修改',

  },
  lin_global: {
    cs_config: '参数配置',
    task_tips: '安装成功,请在任务管理中查看推送进度',
    task_tips2: '推送成功，请在任务管理中查看推送进度',
    ope: '操作',
    pselect: '请选择',
    label_no: '设备编号',
    loading: '数据加载中',
    label_name: '设备名称',
    all_mechanism: '所有渠道商',
    place_areaid: '请选择渠道商',
    time: '时间',
    version: '版本',
    name: '名称',
    remark: '备注',
    edit: '编辑',
    label_model: '设备型号',
    label_type: '设备类型',
    device_type_1: "智能POS",
    device_type_2: "其他设备",
    label_manufid: '设备厂商',
    label_areaid: '渠道商',
    label_areaid_name: '渠道商名称',
    label_address: '设备地址',
    ter_status: '设备状态',
    dest_status: '自毁状态',
    net_status: '联网状态',
    run_status: '外设状态',
    online: '在线',
    offline: '离线',
    new_add: '新增',
    normal: '正常',
    marn: '预警',
    fault: '故障',
    success_tips: '操作成功',
    concel_tips: '已取消',
    zlxfs_tips: '指令下发成功',
    sb_tips: '操作失败，终端已离线',
    czsb: '操作失败',
    zl_error: '指令下发出错',
    all_status: '所有状态',
    delete_success: '删除成功',
    look_detail: '查看详情',
    ter_num: '设备数量',
    ota_bao: 'OTA包',
    ple_sel_ota: '请选择OTA包',
    unlock_success: '解锁成功',
    risk_name: '配置名称',
    risk_type: '预警类型',
    risk_radius: '围栏半径(KM)',
    risk_city: '设定省市',
    risk_desc: '描述',
    risk_warn_info: '风控预警信息',
    warn_event: '预警事件',
    city: '城市',
    jwd: '经纬度',
    distance: '超出设定距离(KM)',
    ccwl: '超出围栏',
    sbyj: '设备预警',
    done: '已处理',
    undone: '未处理',
    roles_tips: '请选择角色',
    roles_place: '通过昵称查找',
    userName: '用户名',
    nickName: '昵称',
    phoneNum: '手机',
    roleName: '角色',
    jh: '激活',
    dj: '冻结',
    phoneNum2: '手机号码',
    resetPass: '重置密码',
    revisePass: '修改密码',
    oldPass: '旧密码',
    newPass: '新密码',
    comfirmPass: '确认密码',
    plePassTips: '请输入密码',
    plePassTipsAgain: '请再次输入密码',
    pwdDisfault: '两次输入密码不一致',
    unfitPhone: '手机号码不合法',
    nickNameTips: '昵称不能为空',
    userNameTips: '用户名不能为空',
    phoneNumTips: '手机号码不能为空',
    roleidTips: '角色不能为空',
    mechanismIdTips: '渠道商不能为空',
    userStatusTips: '请设置用户状态',
    editPage: '编辑页面',
    addPage: '添加页面',
    status: '状态',
    refs: '请完善资料',
    user: '账号',
    logStartTime: '日志开始时间',
    logEndTime: '日志结束时间',
    download: '下载',
    ddsc: '等待上传',
    scz: '上传中',
    scsb: '上传失败',
    sccg: '上传成功',
    rz_tips: '日志获取成功，请在日志管理中查看下载进度',
    hqrz: '获取日志',
    logoTitle: '智能POS终端管理平台',
    hello: '您好',
    wdzl: '我的资料',
    tcxt: '退出系统',
    yhdl: '用户登录',
    zh: '账号',
    password: '密码',
    jzmm: '记住密码',
    login: '登录',
    bah: '深圳市证通电子股份有限公司 © 1993-2020 版权所有 粤ICP备12035887号',
    qsrzh: '请输入账号',
    qsrmm: '请输入密码',
    error: '错误',
    wlzt: '网络状态',
    ckxq: '查看详情',
    wlmc: '围栏名称',
    wllx: '围栏类型',
    bdsb: '绑定设备',
    tjbd: '添加绑定',
    bjwl: '编辑围栏',
    wxzyjlx: '请选择预警类型',
    cityName: '城市名称',
    sfjxpljb: '是否进行批量解绑',
    qxzyjbdzd: '请选择要解绑的终端',
    jbcg: '解绑成功',
    sfjbczd: '是否解绑此终端',
    sfjxplbd: '是否进行批量绑定',
    qxzybddzd: '请选择要绑定的终端',
    bdcg: '绑定成功',
    sfbdczd: '是否绑定此终端',
    xzwl: '新增围栏',
    qdxysccwl: '确定需要删除此围栏',
    tsazcs: '推送安装测试',
    shzt: '审核状态',
    pass: "通过",
    notPass: "不通过",
    waitOne: "待送审",
    waitTwo: "待审核",
    shyy: '审核原因',
    zdtslb: '终端推送列表',
    xztghbtg: '选择通过或者不通过',
    qrtj: '确认提交',
    shcg: "审核成功",
    syqdsty: '所有渠道商通用',
    notBlankName: "名称不能为空",
    notBlankVer: '版本号不能为空',
    qxzlx: '请选择类型',
    qxzscwj: '请选择上传文件',
    zdqds: '指定渠道商',
    sfsyzdqm: '是否使用渠道商证书进行自动签名',
    qmzst: '签名证书',
    azbdz: '安装包地址',
    qscapkwj: '请上传apk文件，且不超过50M',
    qsczipwjls50: '请上传zip文件，且不超过50M',
    jwjtdcc: '将文件拖到此处，或',
    djsc: '点击上传',
    xgscwj: '修改上传文件',
    otaName: '名称',
    xtlx: '系统类型',
    syatemR: '系统ROM',
    sysjota: '系统升级包OTA',
    waitOne: "待送审",
    waitTwo: "待审核",
    verifyPass: '通过',
    verifyNotPass: '不通过',

    confirmDelete: "确定删除?",
    tjshcg: '提交审核成功',
    qdtjsh: '确定提交审核',
    allType: '所有类型',
    smVerify: '提交审核',
    downNumber: '下载次数',
    tgmccz: '通过名称查找',
    upload: '上传',
    xzqddhwj: '选择启动动画文件',
    qxzkjlogo: '选择开机LOGO',
    tpxzds: '图片最佳尺寸300x300,体积不大于2m',
    zmlaun: '选择定制桌面launcher',
    xtjcb: '选择系统基础包',
    null: '无',
    shebei: '设备',
    tslxxx: '推送类型',
    xzbbbbb: '选择OTA包',
    uploadTime: "上传时间",
    verTips: '基于此版本生成的差分包，版本号不带v或version等字符，纯数字，如：2.2.4',
    verTips1: '版本号不带v或version等字符，纯数字，如：2.2.4',
    bbhgsbd: '版本号格式不对',
    lkymtips: '有文件正在上传, 是否确定离开此页面',
    znscziptips: '只能上传zip文件',
    qsczipwj: '请上传zip文件',
    //20170727新增edit by linziying
    danweikm: '单位KM',
    weilanshuoming: '说明：以设备最后一次心跳的经纬度为围栏中心',
    pleaseUpload: '请上传',
    zdqmTips: '是否绑定渠道商证书自动签名',
    zhidingqdsxx: '指定渠道商信息',
    selectWenjian: '选择文件',
    qrjxmm: '确认执行此命令：',
    cicaozuo: '操作？',
    shebeiedit: '设备编辑',
    yxpztitle: '邮箱配置',
    yjyouxiang: '报警邮箱',
    chongzhi: '重置',
    ljchangjian: '立即创建',
    ympeizhi: '域名配置',
    fwqdizhi: '服务器地址',
    fwqdztips: '地址不需要带"http://"字符，可以是域名地址也可以是IP地址，如：www.baidu.com或者127.0.0.1',
    fwqduankou: '服务器端口',
    duankoutips: '端口号不要加":"直接填写数字，如：8080',
    tuisongpeizhi: '推送配置',
    tuisongjl: '推送记录',
    tuisonglx: '推送类型',
    chenggong: '成功',
    shibai: "失败",
    tuisongtime: '推送时间',
    chongtui: '重推',
    shebeibei: '设备',
    fwqdzbnwk: '服务器地址不能为空',
    fwqdkhbnwk: '服务器端口号不能为空',
    wdct: '确定重推',
    tuisongtips: '是否确定推送以下域名配置，推送成功后重启生效。',
    //20170731 lin add
    china: '中文',
    english: '英文',

    //20170804 lin add
    cjzs: '创建证书',
    createTime: '创建时间',
    certificateName: '证书名称',
    xiafa: '下发',
    dachuzhengshu: '导出证书',
    guojia: '国家',
    shengfen: '省份',
    gongsi: '公司',
    youxiang: '邮箱',
    youxiaoqi: '有效期',
    certTypeLabel: '证书类型',
    certForManufacturer: '厂商证书',
    certForCustomer: '客户证书',
    danweitian: '单位：天',
    xinjian: '新建',
    notNull: '不能为空',
    bitian: '必填',
    guojiatips: '国家缩写，如CN',
    shenfentips: '省份英文／拼音，如GuangDong',
    cityTips: '城市英文／拼音，如GuangZhou',
    gongsiTips: '公司英文／拼音，如SZZT',
    emailTips: '请输入邮箱地址',
    youxiaoqiTips: '请输入证书有效期，如365',
    xuantian: '选填',
    srgsbzq: '输入格式不正确',
    cszss: '厂商证书',
    khzss: '客户证书',
    sccszss: '上传厂商证书',
    zhengshu: '证书',
    qudaoshangxinxi: '渠道商',
    quorter: '请选择渠道商或填写设备编号',
    xiafalishi: '下发历史',
    resXiafa: '重新下发',
    chongxintuisong: '重新推送',
    tuisongleixing: '推送类型',
    dachusiyao: '导出私钥',
    shuaxin: '刷新列表',
    passWordTips: '密码不能为空',
    //20170804 lin add end

    //20170821 lin add
    daochugongyao: '导出证书',
    //20170821 lin add end


    //20170822 lin add
    zhengshuType: '渠道商证书类型',
    ziguan: '自管',
    daiguan: '代管',
    //20170822 lin add end

    //20171023 add by sing
    add_merchant: '新增渠道商',


  },
  //edit lin
  terminal: {
    //添加设备

    add: {
      //label值
      //放在global

      //placeholder值
      place_no: "请输入设备编号",
      place_name: '请输入设备名',
      place_terminal: '请选择设备',
      place_model: '请选择设备型号',     //also rules
      place_type: '请选择设备类型',      //also rules
      place_manufid: '请选择厂商',      //also rules
      //also rules
      place_address: '请输入设备地址',  //also rules
      place_actime: '请输入设备激活时间',  //also rules
      place_extime: '请输入设备过期时间',  //also rules
      //popover值
      popover_no: '设备编号由长度不大于50位的字母、数字或下划线组成！',
      popover_name: '设备名由长度不大于50位的汉字、字母、数字或下划线组成！',
      //校验规则
      rules_no_1: '设备编号不能为空',
      rules_no_2: '设备编号长度不能大于20位',
      rules_no_3: '设备编号由字母、数字或下划线组成',
      rules_no_4: '设备编号已存在！',
      rules_name_1: '设备名不能为空',
      rules_name_2: '设备名称长度不能大于30位',
      rules_name_3: '设备名称由汉字、字母、数字或下划线组成',
      //提交弹出提示
      success: '添加成功',
      change_success: '修改成功',


    },
    appBind: {
      label_name: '应用名称',
      label_version: '版本号',
      label_size: '应用大小',
      place_name: '输入应用名称搜索',
      empty_tips: '请选择你要绑定的应用!',
      install_tips: '确定需要安装此应用?',
      five_tips: '一次绑定的应用不能超多五个',

    },
    appList: {
      label_name: '应用名称',
      label_type: '应用类型',
      label_version: '版本号',
      label_time: '绑定时间',
      format_status1: '普通应用',
      format_status2: '系统应用',
      tips1: '确定需要卸载此应用',
      tips2: '解除绑定成功',

    },
    appLog: {
      start_time: '开始时间',
      end_time: '结束时间',
      log_type: '日志类型',
      log_content: '日志内容',


      num: '设备数量',
      tower: '台',

    },
    details: {
      regain: '恢复出厂设置',
      run_log: '运行日志',
      risk_info: '风控信息',
      app_list: '应用列表',
      app_install: '应用安装',
      send_animate: '推送动画',
      reset_animate: '还原动画',
      base_info: '基本信息',
      system_info: '系统信息',
      launcher: 'launcher版本',
      system_version: '系统版本',
      system_spversion: '安全芯片版本',
      ota_version: 'OTA版本',
      hard_version: '固件版本',
      last_time: '最后更新时间',
      net_type: '网络类型',
      online_time: '在线时长',
      run_time: '运行时长',
      hard_info: '硬件信息',
      Electric_quantity: "电量",
      network: "网络",
      cpu: 'CPU信息',
      mem: '内存信息',
      cpuUsed: 'CPU使用率',
      memUsed: '内存使用率',
      hydh: '还原动画',
      tips: '请选择动画还原类型',
      kjdh: '开机动画',
      gjdh: '关机动画',
      kjlogo: '开机LOGO',
      alldhlogo: '所有(动画和LOGO)',
      zbhy: '暂不还原',
      mshy: '马上还原',
      tsdh_title: '推送动画',
      animate_name: '动画名称',
      animatType: '类型',
      position: '播放位置',
      createTime: '定制时间',
      animate: '动画',
      kjlogo: '开机LOGO',
      kj: '开机',
      gj: '关机',
      kgj: '开关机',
      com_send: '确定推送',
      cover_send: '覆盖推送',
      skip_send: '跳过推送',
      comfirm_send: '确定推送此动画?',
      comfirm_hy: '确定还原此动画?',
      hy_success: '还原成功',
      hy_type: '请选择还原动画类型',
      open_abd: '打开ADB',
      close_abd: '关闭ADB',
      if_ope: '是否进行此操作',

    },
    list: {
      add_btn: '添加设备',
      import_btn: '导入设备',
      ztgxsj: '状态更新时间',
      ac_time: "激活时间",
      ec_time: "过期时间",
      import_title: '导入设备信息',
      xqwj: '选取文件',
      qrdr: '确认导入',
      import_muban: '下载导入模板',
      notify_title: '导入结果提示',
      delete_tips: '此操作将永久删除该设备, 是否继续',
      deletes_tips: '此操作将永久删除所选设备, 是否继续?',
      empty_tips: '请选择要删除的设备',
      /*20170731新加*/
      excel_tips: '只能上传Excel文件，且不超过10M',

    },
    OtaList: {
      lock_num: '锁定设备数',
      lock_tips: '确定需要解锁此OTA?',

    },
    terRisk: {
      fkpz: '风控配置',
    }
  },
  account: {
    delete_tips: '确定需要删除此用户',
  },
  // edit mao
  mao_global: {
    btn: {
      sort: "排序",
      e: "操作",
      cancel: "取消",
      add: "添加",
      edit: "编辑",
      submit: "提交",
      update: "修改",
      delete: "删除",
      ok: "确定",
      selectAll: "全选",
      unSelectAll: "全不选",
      reset: "重置",
      createNow: "立即创建",
      confirmUpdate: "确定修改"
    },
    tip: {
      text: "提示",
      confirmDelete: "确定删除?",
      examine: "审核",
      pleaseSelect: "请选择",
      pleaseInput: "请输入",
      search: "查询",
      notBlank: "不能为空",
      success: "成功",
      fail: "失败",
      notPassExamine: "未审核通过",
      groundsForRefusal: "请填写拒绝理由",
      notReset: "删除后将不能恢复"
    }
  },
  /*菜单*/
  menu: {
    home: "首页",
    terManage: "设备管理",
    terManageSub: {
      myTer: "我的设备",
      breakup: "终端备份",
      lockOTA: "终端锁定",
      map: "终端地图",
      log: "日志管理",
      addTer: "添加设备",
      detailTer: "终端详情",
      riskInfo: "风控信息",
      runLog: '运行日志',
      appList: '应用列表',
      appInstall: '应用安装',
      otaLock: 'OTA锁定',

    },
    advertManage: "广告管理",
    advertManageSub: {
      list: "广告列表",
      examine: "广告审核",
      examineVideo: "视频广告审核",
      examineDetail: "审核详情",
      edit: "编辑广告",
      editVideo: "编辑视频广告",
      detail: "广告详情",
      vlist: "视频广告列表",
      vverify: "视频广告审核",
      addVideo: "添加视频广告",
      dfVList: "默认视频列表",
      addDfVideo: "添加默认视频"
    },
    appManage: "应用管理",
    appManageSub: {
      list: "应用列表",
      market: "应用市场",
      custom: "添加到我的定制",
      viewApp: "查看应用",
      customPush: "定制推送",
      appPush: "推送应用",
      appBind: "应用绑定终端",
      examine: "应用审核",
      verifyApp: "审核应用",
      appEdit: '应用编辑',
      appDetail: '应用详情',
      uploadNew: '上传新版本',
      uploadApp: '上传应用'
    },
    taskManage: "任务管理",
    taskManageSub: {
      list: "正在推送任务",
      detail: "正在推送任务详情",
      listHis: "已完成任务",
      detailHis: "已完成任务详情"
    },
    dataManage: "数据管理",
    dataManageSub: {
      channel: "渠道商管理",
      factory: "厂商管理",
      terClassify: "设备类型管理",
      terNum: "设备型号管理",
      advertClassify: "广告类型管理",
      appClassify: "应用类型管理",
      newChannel: "新增渠道商",
      editChannel: "编辑渠道商",
      newFirm: "新增厂商",
      editFirm: "编辑厂商"
    },
    railManage: "风控管理",
    railManageSub: {
      penSetting: "围栏设置",
      warnSetting: "预警信息",
      riskDetail: "围栏详情",
    },
    //lin add 20170804
    safeManage: "安全管理",
    safeManageSub: {
      certificate: "证书管理",
      certNew: "创建证书",
      remote: "远程授权",
      certUpload: "上传厂商证书",
      certDetail: "证书详情",
      cerUpload: "上传证书",
      myCert: '我的证书'
    },
    //lin add 20170804 end
    sysManage: "系统管理",
    sysManageSub: {
      romul: 'OTA上传',
      romed: 'OTA编辑',
      romOTA: "OTA管理",
      examine: "OTA审核",
      push: "OTA推送",
      order: "系统定制",
      animation: "动画定制",
      animateCustom: "定制动画",
      animatePush: "动画推送",
      pushHistory: "推送历史",
      firmwareManage: '固件管理',
      firmwareUpload: '固件上传',
      firmwareEdit: '固件编辑',
      firmwareCheck: '固件审核',
      firmwareCheckDt: '审核详情',
      firmwarePush: '固件推送',
      firmwarePushDevice: '固件推送设备',
      launchManage: 'launcher管理',
      launchCheck: 'launcher审核',
      verifyLaunch: '审核launcher',
      addLaunch: '添加launcher',
      launchDetail: 'launcher详情',
      launchEdit: 'launcher编辑',
      launchNewVer: 'launcher上传新版',
      launchPush: 'Launcher推送',
      launchPushTer: 'Launcher推送终端'
    },
    setManage: "配置管理",
    setManageSub: {
      role: "角色管理",
      system: "系统配置",
      menu: "菜单列表",
      addRole: "添加角色",
      rightChange: "权限修改",
      logo: 'LOGO设置'
    },
    accManager: "账号管理",
    accManagerSub: {
      account: "账户信息",
      subAccount: "子账户信息",
      addAccount: '新增子账户',
      editAccount: '编辑子账户',
    },
    menuEdit: '菜单编辑'
  },
  /*菜单 END*/
  /*广告*/
  advert: {
    status: "广告状态",
    addAdvert: "新增广告",
    deleteAll: "批量删除",
    all: "全部",
    refusal: "说明理由",
    app: "应用",
    appSub: {
      name: "名称",
      classify: "类型",
      uploadTime: "上传时间",
      version: "版本号"
    },
    isPass: "是否通过",
    pass: "通过",
    notPass: "不通过",
    waitOne: "待送审",
    waitTwo: "待审核",
    addDate: "添加时间",
    addUser: "添加者",
    appName: "应用名称",
    img: "图片",
    name: "广告名称",
    classify: "广告类型",
    position: "广告位置",
    positionSub: {
      banner: "首页Banner",
      starPage: "启动页面"
    },
    jumpType: "跳转类型",
    jumpTypeSub: {
      net: "网页",
      appStore: "应用市场"
    },
    url: "URL",
    channel: "渠道商",
    ableDate: "有效时间",
    beginDate: "开始时间",
    endDate: "结束时间",
    contentImg: "广告内容",
    reset: "重置"
  },
  /*广告 END*/
  /*首页*/
  index: {
    t: "台",
    more: "更多",
    terStatus: "设备概况",
    onlineTer: "在线设备",
    offLineTer: "离线设备",
    warnTer: "预警设备",
    taskList: "任务列表",
    pullApp: "应用下发",
    romUpdate: "ROM更新",
    pullAdvert: "广告推送",
    infoList: "信息列表",
    riskWarn: "风控警告",
    breakWarn: "故障警告"
  },
  /*首页 END */

  /*配置管理*/
  menuConfig: {
    menu: {
      addMenu: "添加父级菜单",
      addMenu2: "添加菜单",
      refreshMenu: "刷新菜单",
      menuName: "菜单名称",
      selectModel: "请选择模块",
      orderBy: "排序序号",
      notBlankName: "名称不能为空",
      editMenu: "编辑菜单",
      editSuccess: "编辑成功",
      addSubMenu: "添加子菜单",
      relUrl: "相对地址"
    },
    // 配置管理 - 角色管理
    role: {
      addRole: "新增角色",
      no: "编号",
      name: "名称",
      mark: "描述",
      model: "模块",
      updatePermission: "修改权限",
      editRole: "角色编辑",
      notBlankName: "名称不能为空",
      updateSuccess: "更新成功",
      deleteSuccess: "删除成功",
      modelSelect: "模块选择",
      addSuccess: "添加成功"
    }
  },
  /*配置管理 end*/

  /* 任务管理 */
  /* add by sing, 2017-10-26 */
  taskTypeNames: {
    ALL: "所有类型",
    APP: "应用",
    OTA: "OTA",
    ROM: "ROM",
    FIRMWARE: "固件",
    AD: "广告",
    STARTUP_ANIMATION: "开机动画",
    SHUTDOWN_ANIMATION: "关机动画",
    STARTUP_SHUTDOWN_ANIMATION: "开关机动画",
    LOGO: "开机LOGO",
    LAUNCHER: "Launcher",
    WALLPAPER: '桌面壁纸'
  },

  app_adname: '广告名称',
  app_allpush: '推送全部',
  app_fipush: '文件导入推送',
  app_isjtoviewtd: '是否跳转到任务详情查看推送进度',
  app_mgsys: '管理系统域名',
  app_edcode: '维护授权码',
  app_sapp: '请选择应用',
  app_spic: '请选择图片',
  app_iappnamesrch: '请输入应用名称查询',
  app_alltyps: '全部类型',
  app_allpp: '全部播放位置',
  app_addur: '广告时长',
  app_vsize: '视频尺寸',
  app_addtime: '添加时间',
  app_psverify: '通过审核',
  app_vpreview: '视频预览',
  app_cstandt: '选择时长和次数',
  app_additv: '添加时长',
  app_vdofile: '视频文件',
  app_filename: '文件名称',
  app_vdodur: '视频时长',
  app_misstokentip: '丢失登录信息,需要重新登录授权',
  app_clreulvdo: '点击重新上传视频',
  app_adddfvdeoad: '添加默认视频广告',
  app_addps: '添加人员',
  app_pltimes: '播放次数',
  app_pldur: '播放时长',
  app_csvldate: '选择有效期',
  app_advdoad: '添加视频广告',
  app_mgdfvdo: '管理默认视频',
  app_adstatus: '广告状态',
  app_addadtype: '新增广告类型',
  app_newapptype: '新增应用类型',
  app_addmodel: '新增型号',
  app_newdvtype: '新增设备类型',
  app_addfmname: '新增厂商名称',
  app_srpush: '确认推送',
  app_ulfile: '上传文件',
  app_ttpsddvnum: '本次推送完成设备数量',
  app_srsktsdv: '你确定跳过这些设备',
  app_cvpush: '覆盖推送',
  app_skpush: '跳过推送',
  app_pssuccess: '推送成功',
  app_nowjump: '立即跳转',
  app_bcrecov: '批量还原',
  app_skintro: '简介',
  app_addlc: '添加launcher',
  app_ulinsfile: '上传安装文件',
  app_clreul: '点击重新上传',
  app_lcname: 'launcher名称',
  app_rsfivemin: '每5分钟自动刷新',
  app_suresm: '确认提交',
  app_udfiletype: '更新文件类型',
  app_plsltype: '请选择类型',
  app_adnamenotnull: '广告名称不能为空',
  app_plslchannel: '请选择渠道商',
  app_plslplpos: '请选择播放位置',
  app_slsttime: '请选择开始时间',
  app_slendtime: '请选择结束时间',
  app_addsc: '添加成功',
  app_vlsuccess: '审核成功',
  app_opsuccess: '操作成功',
  app_srpassvf: '确认通过审核',
  app_addvdoad: '添加视频广告',
  app_edvdoad: '编辑视频广告',
  app_sllimit: '选择有效期',
  app_srmuldel: '确认批量删除',
  app_sttcanlateendtime: '开始时间不能晚于结束时间',
  app_etcanelsttime: '结束时间不能早于开始时间',
  app_srdelpush: '确认删除推送',
  app_srrecovsysdf: '确认还原为系统默认的',
  app_rdless: '围栏半径小于',
  app_rdneedmore: '围栏半径需大于',
  app_srban: '确认不通过',
  app_banandrs: '是否不通过?请输入不通过原因',
  app_trjmap: '轨迹地图',
  app_psdonelftip: '本次推送有{num}台设备已完成推送或正在推送，您要跳过这些设备吗？',  // app_ttpsddvnum
  app_psscandtip: '推送成功提示安装',
  app_csulpicbsis: '点击上传图片格式文件(jpg、png、gif...)，最佳显示尺寸为',
  app_srch: '搜索',
  app_lkdevice: '查找设备',
  app_app: '应用',
  app_firmw: '固件',
  app_refresh: '刷新',
  app_sleep: '休眠',
  app_ccdown: '取消下载',
  app_srchcontent: '搜索内容',
  app_account: '帐号',
  app_opecontent: '操作内容',
  app_opetime: '操作时间',
  app_frzaccount: '冻结帐号',
  app_operator: '操作人',
  app_userip: '用户IP',
  app_deskwp: '桌面壁纸',
  app_channelmcdetail: '渠道商详情',
  app_channellevel: '渠道商等级',
  app_cermanage: '证书管理',
  app_lineimportcer: '产线导入证书',
  app_devicemanage: '设备管理',
  app_fileimportdevice: '文件导入设备',
  app_lineimportdevice: '产线导入设备',
  app_prodmodel: '产品型号',

  app_plimportcer: '产线导入客户证书',
  app_importslorder: '导入已选订单',
  app_importslcustomer: '导入已选客户',
  app_customername: '客户名称',
  app_orderno: '订单号',
  app_orderfinishdate: '订单完成日期',
  app_customerno: '客户编码',

  app_debuginfo: '调试信息',
  app_adbstatus: 'ADB状态',
  app_on1: '开',
  app_off1: '关',
  app_devicemode: '设备模式',
  app_normalmode: '正常模式',
  app_debugmode: '调试模式',
  app_signstatus: '验签状态',
  app_catchlog: '抓取日志',
  app_tobenimportdv: '即将导入设备',
  app_lineimporttip: '请设置设备的类型，厂商，型号，地址等基础数据',
  app_cannotwithsysapp: '不能包含系统应用',
  app_locktime: '锁定时间',

  app_risksetting: '风控设置',
  app_lockinfo: '锁定信息',

  app_riskdetail: '预警详情',
  app_lockcity: '锁定城市',
  app_locklngandlat: '锁定经纬度',
  app_lockstate: '锁定情况描述',
  app_bindenclosure: '绑定围栏',
  app_unbindenclosure: '解绑围栏',
  app_sureunlock: '确认解锁',

  app_plsinputimgfile: '请上传img格式文件',
  app_animatefile: '动画文件',

  app_bglock: '后台锁定',
  app_request: '已申请',
  app_unrequest: '未申请',

  app_lockdevice: '锁定设备',
  app_pusheddvlist: '卸载应用',
  app_appuninstall: '客制化卸载',

  app_unlocked: '已解锁',
  app_unlockdevice: '解锁设备',

  app_pushnumcantfive: '推送数量不能超过5个',
  app_selectedappshoupass: '未审核通过的应用不允许推送',

  app_adRefreshfreq: '广告刷新频率',


  app_uninsfail: '卸载失败',
  app_uninssc: '卸载成功',
  app_preversion: '基础版本',

  app_addstfile: '添加配置文件',
  app_filetag: '文件标识',

  app_filestss: '配置描述',
  app_uploadfilest: '上传配置文件',
  app_excludeapp: '排除应用',
  app_reupload: '重新上传',
  app_excludefsttip: '输入应用包名以排除此应用，默认所有支持该文件标识的应用均可使用此配置',

  app_limitxml: '限xml文件',
  app_configfile: '配置文件',

  app_udversion: '更新版本',

  app_udsamexml: '只能更新相同标识xml',
  app_udxmllowertip: '更新的版本低于现版本，将在历史记录中出现，不显示在列表中',

  app_childacmg: '子帐号管理',

  app_unldvwftip: '该设备绑定了围栏【{wl}】,是否同时删除绑定？',

  app_udmode: '更新模式',

  app_append: '追加',


  /*** 非智能设备管理 */
  app_importapp: '导入应用',
  app_adddate: '添加日期',
  app_addtask: '添加任务',
  app_addtesttask: '添加任务测试',
  app_appdesc: '应用描述',
  app_srcdesc: '资源描述',
  app_downapp: '下载应用',
  app_downfile: '下载文件',
  app_addsrc: '添加资源',
  app_importsrc: '导入资源',
  app_srcname: '资源名称',
  app_srcver: '资源版本',
  app_downsrc: '下载资源',
  app_number: '编号',
  app_softinfo: '软件信息',
  app_allstatus: '全部状态',
  app_mstype14: '扫码枪应用推送',
  app_mstype15: '扫码枪资源文件推送',
  /*** end */

  app_filedesc: '文件描述',
  app_filetype: '文件类型',
  app_subtype: '子类型',
  app_addfile: '添加文件',
  app_stmgpsw: '管理密码配置',
  app_mapsl: '地图选择',
  app_bdmap: '百度地图',
  app_map: '地图',
  app_right: '权限',
  app_addconfig: '添加配置',
  app_editconfig: '编辑配置',
  app_mgpsw: '管理密码',
  app_dvconfiglist: '配置设备列表',
  app_appconfigst: '配置应用状态',
  app_applytime: '应用时间',
  app_secrname: '密钥名称',
  app_secrdesc: '密钥描述',
  app_addsecrrule: '添加密钥规则',
  app_editsecrrule: '编辑密钥规则',
  app_secrdvlist: '密钥设备列表',
  app_secrupdatest: '密钥更新状态',
  app_waitupdate: '待更新',


  app_addrandport: '地址与端口',
  app_filepath: '文件路径',
  app_queryudfre: '查询更新频率',
  app_lcupload: '本地上传',
  app_hour: '小时',
  app_addofcloud: '云端添加',
  app_bglist: '后台列表',
  app_cntype: '连接方式',
  app_codegunsrc: '扫码枪资源',
  app_rtosgunsrc: 'RTOS资源',

  app_rots_1: "应用",
  app_rots_2: "资源",
  app_rots_3: "系统",
  app_rots_4: "安全芯片固件",
  app_rots_5: "主控",

  // un process
  app_partpkg: '增量包',
  app_codegunapp: '扫码枪应用',
  app_starttime: '开始时间',

  app_oilmcsrc: '加油机资源',

  app_downtpl: '下载模板',

  app_plsstype: '请选择子类型',

  app_allstyps: '全部子类型',

  app_ftooltip: '动画/LOGO文件在线制作工具',

  app_appendpush: '追加推送',

  app_ipitonlylgchar: '输入项只能是英文数字和下划线等合法字符',

  app_enable: '启用',

  app_spfileis: '文件支持格式为',

  app_cnsetting: '连接设置',

  app_newtask: '新建任务',
  app_adddv: '添加设备',
  app_fileinsst: '文件安装配置',
  app_insscautoop: '安装成功自动打开',
  app_pushsctipins: '推送成功提示安装',
  app_total: '总数',
  app_wait: '等待',
  app_pushing: '正在推送',
  app_pushsldev: '推送已选设备',
  app_repushdv: '重推失败设备',
  app_outputdv: '导出设备',
  app_udtime: '更新时间',
  app_surepsxdv: '确认推送{num}台设备',
  del_allData: "是否确认删除全部数据?",

  app_wite_update: "等待更新",
  app_Update_successfully: "更新成功",
  app_Update_failure: "更新失败",
  app_apppush: '应用推送',
  app_fmwpush: '固件推送',
  app_advpush: '广告推送',
  app_onampush: '开机动画推送',
  app_offampush: '关机动画推送',
  app_onoffampush: '开关机动画推送',
  app_onlgpush: '开机logo推送',
  app_wppush: '壁纸推送',
  app_stfpush: '配置文件推送',
  app_codemc: '扫码器',
  app_codemcsrc: '扫码器资源',
  app_sysud: '系统更新',
  app_fmwud: '固件更新',
  app_anmud: '动画更新',
  app_qcgunsrcps: '扫码枪资源推送',
  app_iscltask: '确定取消任务',
  app_resrc: '资源',
  app_srcfileps: '资源文件推送',

  app_helptip: '帮助提醒',
  app_newpsetnewver: '新版TMS推送功能入口改版',
  app_newptdetail: '	推送功能改版后，用户需要推送可打开推送任务页面（任务管理→推送任务），点击新建任务，进入新建任务页面，输入任务名称并选择需要推送的文件即可新建推送任务。',
  app_newptdetail1: '	任务新建完成后自动跳转至任务详情弹出设备选择，用户可以批量推送或单台设备推送，在任务详情里用户可以多次添加设备，我们建议用户在大批量推送前先推送少量设备，确认无误后在任务详情里点击添加设备再大批量推送。',


  app_daterange: '日期范围',
  app_olinepday: '每日在线数量',
  app_onlineavgt: '平均在线时段',
  app_devicewhe: '设备分布',
  app_statistic: '统计',
  app_today: '今日',
  app_thisweek: '本周',
  app_thismonth: '本月',

  app_addblfile: '添加黑名单文件',
  app_blacklsname: '黑名单名称',
  app_editblls: '编辑黑名单',
  app_blsdesc: '黑名单描述',
  app_blsdvlist: '黑名单设备列表',

  app_wldesc: '围栏描述',
  app_filectncr: '文件内容不正确',

  app_khour: '时',
  app_kday: '日',
  app_yesterday: '昨日',
  app_rc15d: '近15日',
  app_rc30d: '近30日',
  app_stinfo: '状态信息',

  app_croln: '当前在线',
  app_crslp: '当前休眠',
  app_croff: '当前离线',
  app_lstol: '最后在线时间',
  app_lstsl: '最后休眠时间',
  app_lstof: '最后离线时间',
  app_limitiplg: '限制IP段登录',
  app_allowiplg: '允许IP段登录',
  app_illegal: '不合法',
  app_limitiptip: '请输入需要限制的IP段，不输入则不限制',
  app_allowiptip: '请输入允许的IP段，不输入则允许所有IP访问',
  app_unknow: '未知',
  app_hisstatus: '历史状态',
  app_active1: '活跃',
  app_unuse: '未启用',
  app_addpsg: '添加通道',
  app_psgname: '通道名称',
  app_authstat: '授权状态',
  app_cbackad: '回调地址',
  app_bsrqsadwl: '业务请求地址白名单',
  app_appwtls: '应用白名单',
  app_addapppgkn: '添加应用包名',
  app_authopen: '授权开启',
  app_authclose: '授权关闭',
  app_addaddr: '添加地址',
  app_developer: '开发者',
  app_editpasg: '编辑通道',
  app_usertype: '用户类型',
  app_generate: '生成',
  app_gentip: '重新生成AppSecret后，原有AppSecret将失效，并且无法继续接入开放平台。是否确定重新生成AppSecret？',
  app_open1: '开启',
  app_hide: '隐藏',
  app_subtask: '子任务',
  app_sltstype: '选择任务类型',
  app_command: '指令',
  app_addsubts: '添加子任务',
  app_commtype: '指令类型',
  app_taskpros: '任务进度',
  app_cursubts: '当前子任务',
  app_commpush: '指令推送',
  app_dvrestart: '设备重启',
  app_recvorgst: '恢复出厂设置',
  app_recvanimt: '还原动画',
  app_dvlock: '设备锁机',
  app_dvunlock: '设备解锁',
  app_inbdside: '已经到边界了',
  app_subtsnum: '子任务数量',
  app_tscrtime: '任务创建时间',
  app_pushfile: '推送文件',
  app_dvcomm: '设备指令',
  app_ing: '进行中',


  app_core: '内核',
  app_filesys: '文件系统',
  app_commd1fw: '通讯模块1固件',
  app_commd2fw: '通讯模块2固件',
  app_readcfw: '读卡器固件',
  app_pswkbfw: '密码键盘固件',
  app_scanhfw: '扫描头固件',
  app_actpossp: '激活POS通话',
  app_natpossp: '关闭POS通话',
  app_setcallf: '设置通话功能',
  app_clupappdt: '清除应用数据',
  app_isclupappdt: '确定清除应用数据',
  app_impdistbt: '导入渠道商',
  app_impmctip: '待上传文件，仅支持excel且不超过10m',
  app_callfunc: '通话功能',

  app_protocal: '协议',
  app_prtsltip: '选择HTTPS时必须保证接口已支持此协议',
  app_rgsvpm: '授权服务参数',
  app_rgsvip: '授权服务IP',
  app_bgntpm: '后台通知参数',
  app_bgntip: '后台通知IP',
  app_port: '端口',
  app_flexist: '文件已存在',
  app_delcer: '删除证书',
  app_cerid: '证书指纹',
  app_wallpaper: '壁纸',

  app_forceins: '强制安装',
  app_autorun: '安装后自动运行',

  app_cusins: '客制化安装',
  app_cusuins: '客制化卸载',
  app_forcerun: '强制执行',
  app_pushtest: '推送测试',
  app_pltfblt: '平台公告',

  app_addblt: '添加公告',
  app_blttt: '公告标题',
  app_readnum: '阅读次数',
  app_bltct: '公告内容',
  app_pltudrd: '平台已更新',
  app_udlog: '更新日志',
  app_addver: '添加版本',
  app_pubdate: '发布日期',
  app_updct: '更新内容',
  app_editblt: '编辑公告',
  app_editver: '编辑版本',
  app_verupdate: '版本更新',
  app_clviewdt: '点击查看详情',
  app_viewmore: '查看更多',
  app_comptime: '编译时间',
  app_insafnorun: '安装后非自动运行',
  app_normalins: '普通安装',
  app_normalunins: '普通卸载',
  appp_tipoperate: '提示操作',
  app_onlyprov: '只选省份',
  app_filepush: '文件推送',
  app_region: '区域',
  app_srcmechan: '输入关键字搜索渠道商',
  app_ckcode: '验证码',
  app_cantuins: '不可卸载',
  app_ippkgname: '输入包名',
  app_onlypicfm: '只能上传图片格式文件(JPG,PNG,GIF...)',
  app_fludlist: '文件更新列表',
  app_param: '参数',
  app_catching: '正在抓取',
  app_ulding: '正在上传',
  app_ulyet: '上传完成',
  app_endcatch: '结束抓取',
  app_iscatch: '确定开始抓取？',
  app_opterinfo: '导出终端信息',
  app_bcopterinfo: '批量导出信息',
  app_cpttime: '截取时间',
  app_eqcapture: '设备截屏',
  app_scapture: '截屏',
  app_surestcap: '确定进行截屏？',

  app_lokscrn: '锁屏',
  app_ulkscrn: '解屏',
  app_appautrn: 'App自启动',
  app_perms: '单位: 毫秒',
  app_wattime: '等待时间',
  app_lcswitch: 'launcher切换',
  app_appadv: '应用广告',
  app_cardno: '卡号',
  app_trdno: '流水号',
  app_batcno: '批次号',
  app_amout: '金额',
  app_mechno: '商户号',
  app_trdtime: '交易时间',
  app_trddate: '交易日期',
  app_trdcore: '核心流水',
  app_expno: '参考号',
  app_trdtype: '交易类型',
  app_rectime: '记录时间',
  app_fpaddrs: '人脸图片地址',
  app_propcut: '按比例裁剪',
  app_getcash: '取现',
  app_lctrans: '行内转帐',
  app_obtrans: '向他行转帐',
  app_coretrans: '核心流水',
  app_tradeNo: '交易号',
  app_export: '导出',
  app_ctrc: '磁条卡读卡器',
  app_icrc: 'IC卡读卡器',
  app_prtst: '打印机状态',
  app_pswkb: ' 密码键盘',
  app_idfrc: '身份证读卡器',
  app_led: 'led灯',
  app_beep: '蜂鸣器',
  app_codebar: '条码',
  app_lulog: '查看日志',
  app_lust: '查看状态',
  app_mdclst: '模块调用统计',
  app_fcclst: '方法调用统计',

  app_acauth: '激活码授权',
  app_authcode: '激活码',
  app_authrange: '程序有效期',
  app_delact: '暂不激活',
  app_pswtip: '密码必须8位以上，包括大写字母、小写字母、数字和特殊符号',
  app_phontrs: '手机号转帐',
  app_mulfcau: '多因子认证',
  app_verifc: '验证',
  app_opmfackip6dycode: '请打开MFA验证器，输入6位动态验证码',
  app_cantprvmcodectadm: '如不能提供多因子认证验证码，请与管理员联系',
  app_lsstep: '上一步',
  app_nxstep: '下一步',
  app_ckidt: '验证身份',
  app_istapp: '安装应用',
  app_bindmfa: '绑定MFA',
  app_ipaclgpsw: '输入账号登录密码',
  app_bindsfdv: '绑定安全设备',
  app_psfwtsstepop: '请按以下步骤完成绑定操作',
  app_sixnumb: '6位数字',
  app_phdnalyappggidck: '请在手机端下载并安装阿里云APP/Google Authenticator（身份验证器）',
  app_ipappstsagidck: 'iphone：在AppStore搜索阿里云APP/Google Authenticator（身份验证器）',
  app_adappmksagidck: 'Android：在应用市场搜索阿里云APP/Google Authenticator（身份验证器）',
  app_afistclnxitbpagiinx: '安装完成后点击下一步进入绑定页面（如已安装，直接进入下一步）',
  app_usalyagidckscqrc6code: '使用阿里云APP/Google Authenticator（身份验证器）扫描以下二维码，获取6位验证码',
  app_sftkck: '安全令牌验证',
  app_ip6codeubac: '输入6位验证码解除绑定账户',
  app_plipopenalyappoggidckip6dycd: '请在手机中打开阿里云APP或Google Authenticator（身份验证器）,请输入6位动态码',

  app_select_timelist: "选择时间范围",
  app_batch_migration: "批量迁移",
  app_expired_button: "在过去七天内",
  app_sure_migration: "确认迁移",

  app_Batch_import: "批量导入",
  app_Batch_push: "批量导出",
  app_input_sn: "请输入序列号",
  app_serialnumber: "设备号",
  app_serialnumber_new: "新设备号",
  app_termin_status: "设备更新状态",
  app_status_update: "待更新",
  app_status_updated: "已更新",
  app_status_exist: "密钥已存在",
  app_status_fail: "失败",


  app_dyf: "是否下过21号文",
  app_wtk: "是否有密钥",
  app_keyType: "密钥类型",
  app_keyUpIndex: "加密密钥索引",
  app_keyDlIndex: "下载密钥索引",
  app_Algorithm_mode: "算法模式",


  app_start_no: "起始号",
  app_end_no: "截止号",

  auth_status_list: {
    status_1: "鉴权中",
    status_2: "鉴权失败",
    status_3: "生成激活码",
    status_4: "激活码已失效",
    status_5: "激活成功",
    status_6: "激活失败",
  }


}


export default zh_cn;



// WEBPACK FOOTER //
// ./src/components/language/zh_cn.js